// src/api/user.js
import api from "./auth"; // Import from your existing auth.jsx

export const getProfile = () => api.get("/api/user/me");
export const updateProfile = (data) => api.put("/api/user/profile", data);
export const uploadProfilePhoto = (imageFile) => {
    const formData = new FormData();
    formData.append('file', imageFile); // Changed from 'image' to 'file'

    return api.post("/api/user/profile-photo", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const changePassword = (data) => api.post("/api/user/change-password", data);
export const getUserHistory = () => api.get("/api/user/history");
export const getLeaderboard = () => api.get("/api/leaderboard");
export const getUserStats = () => api.get("/api/user/stats");
export const getUserRewards = async () => {
    // This should call your actual rewards API endpoint
    // For now, returning mock data structure
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                data: {
                    totalPoints: 2847,
                    currentLevel: {
                        name: "Eco Champion",
                        icon: "🌟",
                        color: "#43a047"
                    },
                    nextLevelPoints: 3000,
                    unlockedRewards: [
                        { name: "First Classifier", icon: "🎯" },
                        { name: "Green Warrior", icon: "🌱" },
                        { name: "Streak Master", icon: "🔥" }
                    ]
                }
            });
        }, 500);
    });
};

// Settings Management
export const updateUserSettings = async (settings) => {
    try {
        const response = await api.put('/api/user/settings', settings);
        return response;
    } catch (error) {
        console.error('Update settings error:', error);
        throw error;
    }
};

// Export user data
export const exportUserData = async () => {
    try {
        const response = await api.get('/api/user/export');
        return response;
    } catch (error) {
        console.error('Export data error:', error);
        throw error;
    }
};

// Delete account
export const deleteAccount = async () => {
    try {
        const response = await api.delete('/api/user/account');
        return response;
    } catch (error) {
        console.error('Delete account error:', error);
        throw error;
    }
};

export const getUserFeedbackStats = () =>
  api.get('/api/user/feedback-stats');
